import { render, staticRenderFns } from "./SalepointForm.vue?vue&type=template&id=08878c69&scoped=true&"
import script from "./SalepointForm.vue?vue&type=script&lang=js&"
export * from "./SalepointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08878c69",
  null
  
)

export default component.exports